<app-workbench-page [jobsMenu]="jobsMenu" [invoicesMenu]="invoicingMenu" [breadcrumb]="breadcrumb">
    <ul class="cw-tiles" [attr.aria-label]="'resource_admin_dashboard_services' | translate">
      <li class="cw-tile cw-tile--open-jobs">
        <div class="cw-tile__body">
          <h2 class="cw-tile__title">{{ "resource_admin_dashboard_open_jobs" | translate }}</h2>
          <ul class="cw-tile__badges">
            <li class="cw-tile__badge">{{ "resource_admin_dashboard_open_jobs_count" | translate: { count: dashboardCounts.openJobs } }}</li>
            <li class="cw-tile__badge">{{ "resource_admin_dashboard_pending_approval_jobs_count" | translate: { count: dashboardCounts.pendingApprovalJobs } }}</li>
          </ul>
        </div>
        <button class="cw-tile__action" mat-button [matMenuTriggerFor]="jobsMenu" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_open_jobs" | translate }}
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
        </button>
        <mat-menu #jobsMenu="matMenu" class="cw-header-dropdown">
          <button mat-menu-item (click)="openJobs()">{{ "resource_admin_dashboard_open_jobs" | translate }}</button>
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_pending_approval_jobs" | translate }}</button>
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_unallocated_jobs" | translate }}</button>
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_unallocated_ppm_jobs" | translate }}</button>
        </mat-menu>
      </li>

      @if (currentProfileCompany()?.referenceNumber) {
      <li class="cw-tile cw-tile--ppm">
        <div class="cw-tile__body">
          <h2 class="cw-tile__title">{{ "resource_admin_dashboard_bulk_ppm_manager" | translate }}</h2>
          <ul class="cw-tile__badges">
            <li class="cw-tile__badge">{{ "resource_admin_dashboard_open_ppms_count" | translate: { count: dashboardCounts.openPpms } }}</li>
          </ul>
        </div>
        <button class="cw-tile__action" mat-button (click)="openPpmBulkManager()" [disabled]="isRedirectingToWorkbench">
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M4 2h6v6M10 2 4 8M2 4v6h6" /></svg>
          {{ "resource_admin_dashboard_ppm_manager" | translate }}
        </button>
      </li>
      }

      <li class="cw-tile cw-tile--invoicing">
        <div class="cw-tile__body">
          <h2 class="cw-tile__title">{{ "resource_admin_dashboard_invoicing" | translate }}</h2>
          <ul class="cw-tile__badges">
            <li class="cw-tile__badge">{{ "resource_admin_dashboard_awaiting_invoice_count" | translate: { count: dashboardCounts.jobsAwaitingInvoice } }}</li>
            <li class="cw-tile__badge">{{ "resource_admin_dashboard_pending_invoice_count" | translate: { count: dashboardCounts.pendingInvoiceApproval } }}</li>
            <li class="cw-tile__badge">{{ "resource_admin_dashboard_recalled_count" | translate: { count: dashboardCounts.recalledInvoices } }}</li>
            <li class="cw-tile__badge">{{ "resource_admin_dashboard_rejected_count" | translate: { count: dashboardCounts.rejectedInvoices } }}</li>
          </ul>
        </div>
        <button class="cw-tile__action" mat-button [matMenuTriggerFor]="invoicingMenu" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_invoicing" | translate }}
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
        </button>
        <mat-menu #invoicingMenu="matMenu" class="cw-header-dropdown">
          <button mat-menu-item (click)="openJobsAwaitingInvoice()">{{ "resource_admin_dashboard_jobs_awaiting_invoice" | translate }}</button>
          <button mat-menu-item (click)="openSubmittedInvoices()">{{ "resource_admin_dashboard_submitted_invoices" | translate }}</button>
        </mat-menu>
      </li>

      <li class="cw-tile cw-tile--upgrades">
        <div class="cw-tile__body">
          <h2 class="cw-tile__title">{{ "resource_admin_dashboard_upgrade_request_summary" | translate }}</h2>
        </div>
        <button class="cw-tile__action" mat-button (click)="openUpgradeSummary()" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_job_upgrades" | translate }}
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M4 2h6v6M10 2 4 8M2 4v6h6" /></svg>
        </button>
      </li>

      @if (currentProfileCompany()) {
      <li class="cw-tile cw-tile--reporting">
        <div class="cw-tile__body">
          <h2 class="cw-tile__title">{{ "resource_admin_dashboard_reporting" | translate }}</h2>
        </div>
        <button class="cw-tile__action" mat-button [matMenuTriggerFor]="reportsMenu" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_reports" | translate }}
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
        </button>
        <mat-menu #reportsMenu="matMenu">
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_contractor_status_report" | translate }}</button>
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_completed_forms" | translate }}</button>
        </mat-menu>
      </li>
      }

      <li class="cw-tile cw-tile--health-safety">
        <div class="cw-tile__body">
          <h2 class="cw-tile__title">{{ "resource_admin_dashboard_health_safety" | translate }}</h2>
        </div>
        <button class="cw-tile__action" mat-button (click)="openWorkbench()" [disabled]="isRedirectingToWorkbench">
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M4 2h6v6M10 2 4 8M2 4v6h6" /></svg>
          {{ "resource_admin_dashboard_document_library" | translate }}
        </button>
      </li>

      <li class="cw-tile cw-tile--notifications">
        <div class="cw-tile__body">
          <h2 class="cw-tile__title">{{ "resource_admin_dashboard_notifications" | translate }}</h2>
        </div>
        <button class="cw-tile__action" mat-button (click)="openWorkbench()" [disabled]="isRedirectingToWorkbench">
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M4 2h6v6M10 2 4 8M2 4v6h6" /></svg>
          {{ "resource_admin_dashboard_notifications" | translate }}
        </button>
      </li>

      <li class="cw-tile cw-tile--guides">
        <div class="cw-tile__body">
          <h2 class="cw-tile__title">{{ "resource_admin_dashboard_reference_guides" | translate }}</h2>
        </div>
        <button class="cw-tile__action" mat-button [matMenuTriggerFor]="guidesMenu">
          {{ "resource_admin_dashboard_portal_guides" | translate }}
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="m2 4 4 4 4-4" /></svg>
        </button>
        <mat-menu #guidesMenu="matMenu">
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-008-City-Workbench-User-Guide-Overview.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_portal_overview" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-010-City-Workbench-User-Guide-Completing-Job-Closedown.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_job_closedowns" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-011-City-Workbench-User-Guide-Completing-PPM-Forms.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_ppm_forms" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2026/08/PRO-UG-022-City-Workbench-User-Guide-Bulk-PPM-Manager.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_bulk_ppm_manager" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-012-City-Workbench-User-Guide-Submitting-Invoices.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_invoicing" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-009-City-Workbench-User-Guide-Completing-Job-Upgrades.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_job_upgrades" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-013-City-Workbench-User-Guide-Fast-Job-Update-Process.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_fast_job_updates" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-014-City-Workbench-User-Guide-Creating-a-Subcontractor-Administrator-User-Profile.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_create_admin_profile" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2024/04/PRO-UG-016-City-Workbench-User-Guide-User-Management.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_user_management" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2024/04/PRO-UG-015-City-Workbench-User-Guide-Creating-a-Technician-User-Profile.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_create_technician_profile" | translate }}</a>
        </mat-menu>
      </li>

      <li class="cw-tile cw-tile--users">
        <div class="cw-tile__body">
          <h2 class="cw-tile__title">{{ "resource_admin_dashboard_user_management" | translate }}</h2>
        </div>
        <button class="cw-tile__action" mat-button (click)="openUserManagement()">
          {{ "resource_admin_dashboard_user_management" | translate }}
          <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8M7 2l4 4-4 4" /></svg>
        </button>
      </li>
    </ul>
</app-workbench-page>
